import CloseIcon from '../Icons/CloseIcon';
import UserIcon from '../Icons/UserIcon';

export default function HostTips({
  text,
  dismissable,
  onDismiss,
  ...props
}: {
  text: string;
  dismissable: boolean;
  onDismiss: () => void;
}) {
  return (
    <div {...props}>
      <div className="py-20 px-16 rounded-sm border-2 border-accent-2-500 bg-accent-2-100 flex justify-between items-center">
        <UserIcon className="mr-8 shrink-0 size-40" />
        <p className="text-body">
          <span className="text-body-strong">Host Tip:</span> {text}
        </p>
        {dismissable && (
          <CloseIcon className="size-24 shrink-0 self-start cursor-pointer" onClick={onDismiss} />
        )}
      </div>
    </div>
  );
}
